import React from 'react';

const SkeletonLoader = ({ pageSize }) => {
    return (
        <div className="skeleton__grid">
            <div className="agenda-filter-bar skeleton__filter-bar skeleton__animation">
                <button className="skeleton__filter-bar__button"></button>
            </div>

            <div className="course-overview__container">
                <ol className="course-overview">
                    <li className="first-month-seperator"></li>
                    {Array.from({ length: pageSize }).map((_, index) => (
                        <li key={index} className="skeleton__placeholder skeleton__animation">
                            <div className=""></div>
                        </li>
                    ))}
                </ol>
            </div>
        </div>
    );
};

export default SkeletonLoader;
